import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { Section } from './Shared';
export const FAQ = () => {
  const faqs = [{
    q: '¿Sirve si recién empiezo como terapeuta de Chi Kung?',
    a: 'Especialmente si recién empezás. El sistema te da la estructura clínica desde el primer paciente. No tenés que improvisar ni esperar años de experiencia. El Tomo I es tu base operativa, el Tomo II tu biblioteca de sesiones y el Tomo III tu planificación anual.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago recibís un email con el acceso a tu descarga. En menos de 5 minutos tenés todo el Mega Pack disponible.'
  }, {
    q: '¿Necesito imprimirlo todo?',
    a: 'No. Está optimizado para usarse en tablet o computadora durante la consulta. Si preferís imprimirlo, también está diseñado para eso.'
  }, {
    q: '¿Qué lo diferencia de un curso de Chi Kung?',
    a: 'Un curso te enseña técnica. Este pack te da el sistema operativo completo para aplicar lo que ya sabés con criterio clínico, planificación profesional y blindaje energético real. Es la diferencia entre saber manejar y tener el GPS, el manual y el seguro del auto.'
  }, {
    q: '¿Tiene garantía real?',
    a: '100%. 7 días. Sin preguntas. Sin formularios. Si no es lo que esperabas, te devolvemos el dinero completo.'
  }, {
    q: '¿Puedo compartirlo con otros terapeutas?',
    a: 'El pack es de uso personal y profesional exclusivo. No está autorizada su reproducción ni distribución.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="max-w-3xl" data-id="element-69" data-mp="s0m6ot3gk3h5">
      <div className="text-center mb-12" data-id="element-70" data-mp="wy5og2zd6ydu">
        <h2 className="md:text-4xl font-display font-bold uppercase tracking-[0.12em] mb-4 text-[22px] text-brand-burgundy" data-id="element-71" data-mp="wyxjncp1uu3l">
          Lo que más nos preguntan
        </h2>
      </div>

      <div className="space-y-4" data-id="element-72" data-mp="n080lglf33lr">
        {faqs.map((faq, i) => <div key={i} className="glass-panel rounded-2xl overflow-hidden border-brand-goldDark/20" data-id="element-73" data-mp="n1st70o68cgz" data-mpi={i}>
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none hover:bg-brand-surfaceLight/60 transition-colors" data-id="element-74" data-mp="2pog8r43sy24g">
              <span className="font-semibold pr-8 text-brand-goldDark text-[14px] md:text-base lg:text-lg" data-id="element-75" data-mp="2ay0lzkvqmm46">
                {faq.q}
              </span>
              <ChevronDown className={`w-5 h-5 text-brand-goldDark transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-76" data-mp="38kpy4nk5mf3r" />
            </button>
            <AnimatePresence data-id="element-77" data-mp="2yma86nwv5bvu">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-78" data-mp="2yp61u01oheeh">
                  <div className="px-6 pb-5 text-brand-text border-t border-brand-goldDark/15 pt-4 text-[13px] md:text-base leading-relaxed" data-id="element-79" data-mp="1j8xiw8fl7ht4">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
};